<script setup lang="ts">
import { onUnmounted, ref, watchEffect } from "vue";
import { panLeft$, panRight$ } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{
  (event: "left", e: HammerInput): void;
  (event: "right", e: HammerInput): void;
}>();

const r = ref();

let s1;
let s2;
watchEffect(() => {
  if (!r.value) {
    return;
  }
  s1?.unsubscribe();
  s1 = panLeft$(r.value).subscribe((e) => {
    emits("left", e);
  });
  s2?.unsubscribe();
  s2 = panRight$(r.value).subscribe((e) => {
    emits("right", e);
  });
});

onUnmounted(() => {
  s1?.unsubscribe();
  s2?.unsubscribe();
});

defineExpose({});
</script>

<template>
  <div
    ref="r"
    class="pan"
    :style="{ display: 'inline-block' }"
  >
    <slot></slot>
  </div>
</template>

<style></style>
